import React, { useState, useEffect } from 'react';
import './InterviewSchedule.css';

const InterviewSchedule = ({ applicant }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  const groupInterviewsByDate = (applicant) => {
    const groups = {};
    applicant.process_update.forEach(interview => {
      const dateKey = interview.deadline_date;
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(interview);
    });
    return groups;
  };

  const getInterviewerAvatar = (name) => {
    // Generate a simple avatar based on the name
    const firstLetter = name.charAt(0).toUpperCase();
    return `${process.env.REACT_APP_API_URL}/profile/get-pic/${encodeURIComponent(name)}`;
  };

  const groupedInterviews = groupInterviewsByDate(applicant);

  if (loading) {
    return <div className="loading-state">Loading interviews...</div>;
  }

  if (error) {
    return <div className="error-state">{error}</div>;
  }

  return (
    <div className="interview-schedule-container">
      <div className="schedule-content">
        <div className="schedule-header">
          <h2>Interview List</h2>
          <button className="add-schedule-btn">
            <span className="plus-icon">+</span>
            Add Schedule Interview
          </button>
        </div>

        <div className="interviews-list">
          {Object.keys(groupedInterviews).length > 0 ? (
            Object.entries(groupedInterviews)
              .sort(([a], [b]) => new Date(a) - new Date(b))
              .map(([date, dateInterviews]) => (
                <div key={date} className="date-group">
                  <div className="date-header">
                    <h3 className="date-title">
                      {date === new Date().toISOString().split('T')[0] + 1 ? 'Tomorrow - ' : ''}
                      {formatDate(date)}
                    </h3>
                  </div>
                  
                  <div className="interviews-for-date">
                    {dateInterviews.map((interview) => (
                      <div key={interview.process_id} className="interview-card">
                        <div className="interview-info">
                          <div className="interviewer-section">
                            <div className="interviewer-avatar">
                              <img 
                                src={getInterviewerAvatar(interview.posted_by_user_id)} 
                                alt={interview.posted_by_names} 
                              />
                            </div>
                            <div className="interviewer-details">
                              <h4 className="interviewer-name">{interview.posted_by_names}</h4>
                              <p className="interview-type">{interview.title}</p>
                            </div>
                          </div>
                          
                          <div className="interview-schedule">
                            {/* <div className="time-slot">
                              <span className="time">{interview.time_slot || '10:00 AM - 11:00 AM'}</span>
                            </div> */}
                            <div className="location">
                              <span className="location-text">{interview.details || 'Silver Crysta Room, Nomad'}</span>
                            </div>
                          </div>
                        </div>

                        <div className="interview-actions">
                          <button className="more-actions-btn">⋯</button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))
          ) : (
            <div className="empty-state">
              <p>No interviews scheduled</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InterviewSchedule;